module.exports = __webpack_public_path__ + "static/media/filter_list.0d459354.svg";